var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.277,
    height: 103.055,
    viewBox: "0 0 140.277 103.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_accept_tasks_re_09mv",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8606",
    "data-name": "Group 8606",
    transform: "translate(-10.729 -169.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "important",
    transform: "translate(64.438 178.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8600",
    "data-name": "Group 8600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M22.221,4.913,7.814,28.407a2.131,2.131,0,0,0,1.816,3.244H38.971a2.131,2.131,0,0,0,1.816-3.244L26.381,4.913a2.44,2.44,0,0,0-4.16,0Z",
    transform: "translate(-7.5 -3.749)",
    fill: "#ffe177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8601",
    "data-name": "Group 8601",
    transform: "translate(14.351 8.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M238.7,141.92l-10.073-16.427a43.27,43.27,0,0,1-3.732,11.439,44.351,44.351,0,0,1-5.131,8.232h17.12a2.13,2.13,0,0,0,1.816-3.244Z",
    transform: "translate(-219.768 -125.493)",
    fill: "#ffd15b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8602",
    "data-name": "Group 8602",
    transform: "translate(2.55 2.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M45.63,59.606a.41.41,0,0,1-.349-.624L59.253,36.2a.254.254,0,0,1,.434,0L73.66,58.982a.41.41,0,0,1-.349.624Z",
    transform: "translate(-45.22 -36.075)",
    fill: "#feb237"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8605",
    "data-name": "Group 8605",
    transform: "translate(15.503 7.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8603",
    "data-name": "Group 8603",
    transform: "translate(0 13.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.298,
    cy: 1.298,
    r: 1.298,
    fill: "#5a5a5a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8604",
    "data-name": "Group 8604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M238.1,108.806a1.3,1.3,0,0,0-1.3,1.3v9.052a1.3,1.3,0,0,0,2.6,0V110.1A1.3,1.3,0,0,0,238.1,108.806Z",
    transform: "translate(-236.807 -108.806)",
    fill: "#5a5a5a"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M312.2,293.083a37.26,37.26,0,1,1,30.458-58.727l-.353.249a36.829,36.829,0,1,0-.87,43.617l.342.263A37.02,37.02,0,0,1,312.2,293.083Z",
    transform: "translate(-274.943 -216.973)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M511.509,347.315a2.065,2.065,0,1,1,2.065-2.065,2.065,2.065,0,0,1-2.065,2.065Z",
    transform: "translate(-458.846 -314.704)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M516.9,350.353l-.432-.432.432-.432a.2.2,0,0,0-.288-.288l-.432.432-.432-.432a.2.2,0,0,0-.288.288l.432.432-.432.432a.2.2,0,0,0,.288.288l.432-.432.432.432a.2.2,0,0,0,.288-.288Z",
    transform: "translate(-463.517 -319.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 4.11,
    cy: 4.11,
    r: 4.11,
    transform: "translate(38.282 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M463.076,224.607a.457.457,0,0,1-.366-.183l-1.121-1.5a.457.457,0,1,1,.732-.549l.734.978,1.884-2.826a.457.457,0,0,1,.761.507l-2.243,3.364a.457.457,0,0,1-.368.2Z",
    transform: "translate(-421.244 -218.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18152",
    "data-name": "Rectangle 18152",
    width: 12.072,
    height: 2.581,
    rx: 1.291,
    transform: "translate(36.447 11.525)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18153",
    "data-name": "Rectangle 18153",
    width: 24.333,
    height: 2.581,
    rx: 1.291,
    transform: "translate(30.316 16.688)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18154",
    "data-name": "Rectangle 18154",
    width: 24.333,
    height: 2.581,
    rx: 1.291,
    transform: "translate(30.316 21.851)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M453.215,552.562a2.065,2.065,0,1,1,2.065-2.065,2.065,2.065,0,0,1-2.065,2.065Z",
    transform: "translate(-413.13 -475.665)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M458.607,555.6l-.432-.432.432-.432a.2.2,0,0,0-.288-.288l-.432.432-.432-.432a.2.2,0,0,0-.288.288l.432.432-.432.432a.2.2,0,0,0,.288.288l.432-.432.432.432a.2.2,0,0,0,.288-.288Z",
    transform: "translate(-417.801 -480.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 4.11,
    cy: 4.11,
    r: 4.11,
    transform: "translate(25.704 44.286)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10396",
    "data-name": "Path 10396",
    d: "M404.782,429.854a.457.457,0,0,1-.366-.183l-1.121-1.5a.457.457,0,1,1,.732-.549l.734.978,1.884-2.826a.457.457,0,0,1,.761.507l-2.243,3.364a.457.457,0,0,1-.368.2Z",
    transform: "translate(-375.529 -379.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18155",
    "data-name": "Rectangle 18155",
    width: 12.072,
    height: 2.581,
    rx: 1.291,
    transform: "translate(23.869 55.812)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18156",
    "data-name": "Rectangle 18156",
    width: 24.333,
    height: 2.581,
    rx: 1.291,
    transform: "translate(17.738 60.975)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18157",
    "data-name": "Rectangle 18157",
    width: 24.333,
    height: 2.581,
    rx: 1.291,
    transform: "translate(17.738 66.137)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M648.367,506a2.852,2.852,0,1,1,2.852-2.852A2.852,2.852,0,0,1,648.367,506Z",
    transform: "translate(-565.556 -437.919)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M655.813,510.2l-.6-.6.6-.6a.281.281,0,0,0-.4-.4l-.6.6-.6-.6a.281.281,0,0,0-.4.4l.6.6-.6.6a.281.281,0,0,0,.4.4l.6-.6.6.6a.281.281,0,0,0,.4-.4Z",
    transform: "translate(-572.008 -444.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18158",
    "data-name": "Rectangle 18158",
    width: 16.67,
    height: 3.565,
    rx: 1.782,
    transform: "translate(62.175 38.968)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18159",
    "data-name": "Rectangle 18159",
    width: 33.602,
    height: 3.565,
    rx: 1.782,
    transform: "translate(53.709 46.098)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18160",
    "data-name": "Rectangle 18160",
    width: 33.602,
    height: 3.565,
    rx: 1.782,
    transform: "translate(53.709 53.227)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M435.913,425.05h-2.752l-1.31-10.617h4.063Z",
    transform: "translate(-338.67 -325.01)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M695.839,666.195,692.9,665l-.084-.035-1.623,1.23a3.455,3.455,0,0,0-3.454,3.454v.113h8.875v-3.567Z",
    transform: "translate(-598.67 -567.054)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M532.946,416.1l-2.629.817-4.4-9.75,3.88-1.205Z",
    transform: "translate(-412.439 -318.369)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M806.921,659.26l-3.161-.269-.091-.008-1.184,1.656a3.455,3.455,0,0,0-2.274,4.324l.033.107,8.475-2.634-1.058-3.406Z",
    transform: "translate(-686.751 -562.363)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M718.225,422.78l1.12,3.184v1.721l-.156,1.893,1.733,6.312,1.359,13.919,6.84,20.6-5.245,1.51-13.391-33.665-4.229,34.052-4.8-.128a7.353,7.353,0,0,1-.6-3.063c.216-1.079.216.216.216-1.079s-.935-.732-.252-1.769a4.465,4.465,0,0,0,.641-2.569c.043-.625-.389-25.871-.389-26.734a10.5,10.5,0,0,1-.075-1.524c.075-.85,1.023-.5.765-1.97a7.154,7.154,0,0,1-.3-2.312c.043-1.1.637-7.546.637-7.546Z",
    transform: "translate(-608.731 -377.126)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M685.567,360.239l9.615-9.273,2.665-7.546-3.931-1.709c-2.019,1.934-4.2,7.959-4.2,7.959l-6.617,8.418c-.052.018-.1.036-.154.059a1.894,1.894,0,1,0,2.623,2.093Z",
    transform: "translate(-594.023 -313.549)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M732.774,313.029l4.986,1.583.019,0c1.856-.311,3.4-3.342,4.361-5.83a3.472,3.472,0,0,0-1.768-4.4h0a3.48,3.48,0,0,0-3.644.46l-2.56,2.092Z",
    transform: "translate(-633.987 -284.025)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M714.4,309.045l.029-.039c1.556-2.063-.572-7.173-.894-7.914l1.447-.428-.252-2.754-.121-1.228,1.125-1.068,0-.027.773-5.5,1.012-3.643a8.053,8.053,0,0,0-2.083-7.861l-2.069-2.054-2.479-3.88-4.156-.107-1.494,2.655a6.059,6.059,0,0,0-4.846,6.063l.141,7.068-1.491,8.757L699,298.67l-1.464,1.544.271,1.561-1.095.436-.536,2.219a10.035,10.035,0,0,0-1.568,2.44c0,.071.049.142.16.221.875.626,5.762,1.981,7.962,1.166,2.343-.867,11.527.762,11.619.778Z",
    transform: "translate(-604.059 -259.301)",
    fill: "#7648a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M645.589,322.518l-2.123-4.232c-3.081.211-9.2,3.773-9.2,3.773L622.7,324.512a2.09,2.09,0,1,0,.57,3.572l14.719-1.055Z",
    transform: "translate(-545.435 -295.179)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M720.99,295.768l5.544-4.12.977-3.519a3.844,3.844,0,0,0-1.156-3.889h0a3.835,3.835,0,0,0-5.233.169c-2.086,2.083-4.466,4.988-3.955,7l.005.02Z",
    transform: "translate(-621.693 -267.733)",
    fill: "#7648a3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 4.93,
    cy: 4.93,
    r: 4.93,
    transform: "translate(99.962 2.414)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M739.352,224.3a5.779,5.779,0,0,0-2.7-.116c-.91.036-2.013-.307-2.206-1.2-.143-.658.286-1.38.016-2-.295-.673-1.18-.769-1.891-.957a4.358,4.358,0,0,1-3.147-4.079c-.049.368.58.488.786.18a.916.916,0,0,0-.164-1.027,6.218,6.218,0,0,1-.707-.855.72.72,0,0,1,.2-.975,2.739,2.739,0,0,0,1.735,1.427,1.35,1.35,0,0,1,.41-1.327,3.972,3.972,0,0,1,1.254-.738c1.136-.493,2.463-.983,3.564-.414a2.131,2.131,0,0,1,1.1,1.491,4.7,4.7,0,0,1,4.01,4.417c-.125,2.2-.216,2.373-2.044,6.069",
    transform: "translate(-631.216 -211.804)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M857.865,660.065H850.7l-.031-.056c-.092-.166-.18-.342-.263-.523a19.711,19.711,0,0,1-1.324-4.979l-.207-1.2a.742.742,0,0,1,1.167-.725q1.632,1.188,3.266,2.373c.412.3.883.647,1.334,1.023.044-.211.089-.423.135-.632a.742.742,0,0,1,1.355-.234l.838,1.346a4.906,4.906,0,0,1,1.041,3,.164.164,0,0,1,0,.038,2.358,2.358,0,0,1-.122.5Z",
    transform: "translate(-725.032 -557.231)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M675.625,686.632l-68.045.066a.257.257,0,1,1,0-.514l68.045-.066a.257.257,0,1,1,0,.514Z",
    transform: "translate(-535.605 -583.643)",
    fill: "#cacaca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewtask);
export default __webpack_public_path__ + "static/media/viewtask.94197e043b199b00d5b35a54d326f7bb.svg";
export { ForwardRef as ReactComponent };